import axios from 'lib/apiClient';

const BASEURL = 'API/1_0/getEnvironmentVariable.php';

export const getVariables = (brand) => {
  return axios.get(BASEURL, {
    params: {
      brand,
    },
  });
};

export const getVariable = (variable) =>
  axios
    .get(BASEURL, {
      params: {
        variable,
      },
    })
    .then((r) => r[0]);

export const updateEnv = (variable, value) =>
  axios.post('API/1_0/postEnvironmentVariables.php', {
    variable,
    value,
  });
